import React from "react";
 import Footer from "../index";

export function FooterContainer() {
    return(
        <Footer>
            <Footer.Wrapper>
                <Footer.Row>
                <Footer.Column>
                    {/* <Footer.Title>Causes</Footer.Title> */}
                    {/* <Footer.Link href="#">Medical crowdfunding</Footer.Link>
                    <Footer.Link href="#">Cancer Crowdfunding</Footer.Link>
                    <Footer.Link href="#">Education Crowdfunding</Footer.Link>
                    <Footer.Link href="#">Creative Fundraising</Footer.Link>
                    <Footer.Link href="#">Child Welfare</Footer.Link>
                    <Footer.Link href="#">Animal Fundraisers</Footer.Link>
                    <Footer.Link href="#">COVID-19 Relief Fund</Footer.Link> */}
                    <div style={{color:"#fff"}}>
                        <div > <Footer.Title><h1 >Ketto</h1><hr/></Footer.Title></div>
                        <div></div>
                        <div style={{padding:"-10px"}}>
                            <h4>For any queries</h4>
                            <h4>Email: info@ketto.org</h4>
                            <h4>Contact No: +91 9930088522</h4>
                        </div>
                    </div>
                     
                 </Footer.Column>
                <Footer.Column>
                    <Footer.Title>Causes</Footer.Title>
                    <Footer.Link href="#">Medical crowdfunding</Footer.Link>
                    <Footer.Link href="#">Cancer Crowdfunding</Footer.Link>
                    <Footer.Link href="#">Education Crowdfunding</Footer.Link>
                    <Footer.Link href="#">Creative Fundraising</Footer.Link>
                    <Footer.Link href="#">Child Welfare</Footer.Link>
                    <Footer.Link href="#">Animal Fundraisers</Footer.Link>
                    <Footer.Link href="#">COVID-19 Relief Fund</Footer.Link>
                     
                 </Footer.Column>
                <Footer.Column>
                    <Footer.Title>How it works?</Footer.Title>
                    <Footer.Link href="#">Fundraising for NGOs</Footer.Link>
                    <Footer.Link href="#">Sponsor A Child</Footer.Link>
                    <Footer.Link href="#">Fundraising Tips</Footer.Link>
                    <Footer.Link href="#">What is Crowdfunding?</Footer.Link>
                    <Footer.Link href="#">Corporates</Footer.Link>
                    <Footer.Link href="#">Withdraw Funds</Footer.Link>
                    <Footer.Link href="#">Browse Fundraiser</Footer.Link>
                     
                </Footer.Column>
                <Footer.Column>
                    <Footer.Title>About Us</Footer.Title>
                    <Footer.Link href="#">Team Ketto</Footer.Link>
                    <Footer.Link href="#">In The News</Footer.Link>
                    <Footer.Link href="#">Our Partners</Footer.Link>
                    <Footer.Link href="#">Careers</Footer.Link>
                    <Footer.Link href="#">Ketto Blog</Footer.Link>
                    <Footer.Link href="#">Success Stories</Footer.Link>
          
                </Footer.Column>
                <Footer.Column>
                    <Footer.Title>Support</Footer.Title>
                    <Footer.Link href="#">Medical Finance</Footer.Link>
                    <Footer.Link href="#">FAQs & Help Center</Footer.Link>
                    <Footer.Link href="#">Are Ketto Campaigns Genuine?</Footer.Link>
                    <Footer.Link href="#">Fundraiser Video</Footer.Link>
                    <Footer.Link href="#">Trust & Safety</Footer.Link>
                    <Footer.Link href="#">Plans & Pricing</Footer.Link>
                    <Footer.Link href="#">Contact Us</Footer.Link>
                   
                    
                </Footer.Column>
                </Footer.Row>
                <div style={{color:"#fff"}}>
                <hr></hr>
                    <h5>Copyright © 2022 Ketto Online Ventures Pvt Ltd. All Rights Reserved.
 Terms of Use |
 Privacy Policy |
 AML Policy |
 Use of cookies </h5>
                </div>
               
                 
              
                
         </Footer.Wrapper>
        </Footer>
    )
}